// 로딩 화면 랜덤 멘트 리스트
export const loadingMessages = [
    "오늘의 운을 픽셀로 갈아 넣는 중…",
    "별자리들이 회의 중입니다. 잠시만요.",
    "수정구슬에 김이 서려서 닦는 중!",
    "행운 포인트를 소량 충전하는 중… 삐빅.",
    "우주가 답장을 타이핑 중입니다… 또 오타 나면 고칠게요.",
    "오늘의 기운을 와이파이로 수신 중… 신호 세기: ★★★★☆",
    "사주 팔자를 정렬 중… 이건 늘 정렬이 어렵네요.",
    "별들이 자리 바꾸는 중! 잠깐만요, 의자 뺄게요.",
    "운세 요정이 출근 도장을 찍는 중… 지각 아님!",
    "길운이 길을 헤매서 안내하는 중… 여기 맞아요!",
    "나쁜 기운은 휴지통에 버리는 중… (완전삭제)",
    "오늘의 키워드를 몰래 적어두는 중… 들키면 안 돼요.",
    "인생의 RNG(랜덤) 값을 살짝 확인하는 중…",
    "당신의 행운을 0.1% 반짝이게 만드는 중…",
    "별빛을 한 스푼 더 넣는 중… 과하면 눈부셔요.",
    "운명의 톱니바퀴에 윤활유 바르는 중… 끼익 소리 금지.",
    "사소한 복선을 깔아두는 중… (스포 아님)",
    "우주 택배가 도착했습니다. 개봉 중…",
    "오늘의 액운을 우회도로로 보내는 중… 네비 재탐색!",
    "기운 측정기를 흔드는 중… (이상 없음)",
    "긍정 에너지를 세탁기에 돌리는 중… 향기 모드!",
    "별똥별에게 DM 보내는 중… 답장 오면 알려드릴게요.",
    "당신의 기분을 기준으로 운세 온도를 맞추는 중…",
    "\"좋은 일\"을 예약해두는 중… 캘린더 저장!",
    "꿈 해석 사전 펼치는 중… 페이지가 자꾸 접혀요.",
    "운세 레시피에 소금 한 꼬집… (과학은 아니지만요)",
    "초록 보석을 반짝반짝 광내는 중… 행운 연출!",
    "오늘의 조언을 포장하는 중… 리본 묶는 중!",
    "우주의 회전 속도를 잠깐 체크하는 중… 정상 회전!",
    "타이밍 운을 측정하는 중… 지금이 그때일지도?",
    "당신의 별을 찾는 중… 이름표가 떨어졌어요.",
    "행운을 상온에 해동하는 중… (너무 차가우면 놀라요)",
    "미래 힌트를 소근소근 편집하는 중… 스포 방지!",
    "좋은 인연을 살짝 예열하는 중… 따뜻해져라!",
    "운세 서버에 클로버 붙이는 중… 🍀",
    "당신의 행운지수를 살짝 흔들어 균일하게 만드는 중…",
    "잠깐! 우주가 커피 한 잔 하고 온대요.",
    "기운을 정리정돈 중… 라벨 붙이는 중!",
    "당신의 선택지를 반짝이게 조명 설치 중…",
    "운세가 오늘의 BGM을 고르는 중… 둠칫.",
    "별빛 프린터에서 출력 중… 용지 걸림만 아니면…",
    "사주 계산기가 \"띵\" 소리를 내는 중… 거의 다 됐어요.",
    "오늘의 흐름을 지도처럼 펼치는 중… 여기서 좌회전!",
    "기운 필터를 교체하는 중… 새 필터 장착 완료!",
    "당신의 행운을 소심하게 응원하는 중… (파이팅…)",
    "미래를 너무 빨리 보면 놀라니 천천히 여는 중…",
    "작은 기적을 재고 확인 중… 한 개 남았어요!",
    "당신의 별에 먼지가 묻어 털어내는 중… 후후.",
    "운명의 실을 살짝 꼬아 리본 만드는 중… 예쁘게!",
    "오늘의 운세가 거울 보고 있는 중… (자기관리)",
    "액운 방지 마법진을 그리는 중… 삐뚤어도 효과는 있어요.",
    "우주가 결정을 미루는 중… \"음… 그건…\"",
    "별자리들이 박수 치는 중… 이유는 곧 공개!",
    "행운을 소포로 보내기 전에 주소 확인 중… 정확해야 해요.",
    "타이밍이 익는 중… 너무 덜 익으면 딱딱해요.",
    "좋은 소식의 포장지를 고르는 중… 무늬는 랜덤!",
    "오늘의 운을 \"업데이트\"하는 중… 재시작은 하지 말아주세요(?)",
    "당신의 직감을 살짝 칭찬하는 중… 잘하고 있어요.",
    "운세가 '말투'를 고민하는 중… 존댓말 vs 반말…",
    "우주 신호가 약해서 안테나를 세우는 중… 삐빅!",
    "별똥별에게 소원 AS 요청하는 중… 접수 완료.",
    "오늘의 행운에 스파클 효과 넣는 중… ✨",
    "당신의 운을 안전하게 운반하는 중… 흔들림 주의!",
    "\"괜찮아질 거야\" 버튼을 눌러보는 중… 딸깍.",
    "나쁜 기운은 스킵! 스킵! 하는 중…",
    "금전운을 계산하는 중… 잔돈까지 정확히!",
    "인연운을 살짝 정리하는 중… 너무 얽히면 풀어야죠.",
    "기회가 문 앞까지 왔는지 CCTV 확인 중…",
    "별자리별 투표 결과 집계 중… 과반 넘었나요?",
    "오늘의 조언을 한 번 더 검수하는 중… 오탈자 체크!",
    "운세가 손을 씻고 오는 중… 청결이 행운의 기본!",
    "우주가 당신에게 '끄덕'하는 중… (의미심장)",
    "행운을 살짝 저축하는 중… 이자 붙나요?",
    "오늘의 기운을 \"부드럽게\" 만드는 중… 말랑말랑.",
    "당신의 운세를 안전 모드로 실행 중… 무서운 말 금지!",
    "별빛을 모으느라 잠깐 어두워요… 금방 켤게요.",
    "운세가 스스로를 믿는 중… 당신도 같이 믿어줘요.",
    "오늘의 힌트를 과자 봉지처럼 바스락 열어보는 중…",
    "소소한 행운을 주머니에 넣는 중… 떨어뜨리지 마요!",
    "우주가 \"답 정했어!\" 하고 외치는 중… 곧 전달!",
    "오늘의 조언을 더 귀엽게 번역하는 중…",
    "운명의 나침반이 북쪽을 가리키는지 확인 중… (대충 맞음)",
    "별들이 서로 자리 바꾸다 꼬여서 푸는 중…",
    "당신의 하루에 좋은 구두점을 찍는 중… 마침표가 아니라 느낌표!",
    "운세가 신발 끈 묶는 중… 준비 운동 완료.",
    "행운을 살짝 \"확률 업\"하는 중… 치트키는 아니에요.",
    "오늘의 감정선을 부드럽게 정렬하는 중…",
    "우주가 조용히 손 흔드는 중… 안녕~",
    "당신의 운세를 한 줄로 요약하려다 실패하는 중… (너무 드라마틱)",
    "별빛 알람을 맞추는 중… 적당히 울리게요.",
    "오늘의 흐름을 파도처럼 그리는 중… 서핑 준비!",
    "마지막으로 행운에 광택 코팅하는 중… 반짝반짝 완료!"
];

// 랜덤 멘트 선택 함수
export const getRandomMessage = () => {
    const randomIndex = Math.floor(Math.random() * loadingMessages.length);
    return loadingMessages[randomIndex];
};
